import { render, staticRenderFns } from "./modal_add.vue?vue&type=template&id=6feb3b82&scoped=true&"
import script from "./modal_add.vue?vue&type=script&lang=js&"
export * from "./modal_add.vue?vue&type=script&lang=js&"
import style0 from "./modal_add.vue?vue&type=style&index=0&id=6feb3b82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6feb3b82",
  null
  
)

export default component.exports